import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import { getText } from '../../../../util/dictionary';
import ContinueManager from '../../../../util/continue-handler';
import ViewMoreImages from './ViewMoreImages/ViewMoreImages';

export default class MiniBasketOverlay extends Component {

  constructor(props) {
    super(props);

    this.updateMiniBasket = this.updateMiniBasket.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  updateMiniBasket(event, buttonText) {
    event.stopPropagation();
    const miniBasketButtons = [...document.querySelectorAll('.MiniBasket_box')];

    for (let i = 0; i < miniBasketButtons.length; i++) {
      const textItem = miniBasketButtons[i].querySelector('.MiniBasket_buttonTitle');
      if (textItem.innerText.toLowerCase() === buttonText.toLowerCase()) {
        miniBasketButtons[i].click();
        break;
      }
    }
  }

  continueBookingProcess = (event) => {
    event.stopPropagation(); 
    ContinueManager.handleClick(event);
  }

  dictionary = (route) => {
    return getText(route, this.props.dictionary);
  }

  render() {
    const { 
      carHires,
      extras,
      flights,
      isDesktop,
      miniBasketModel,
      search,
      selectedHotel,
      transfer
    } = this.props;

    const transferText = carHires ? this.dictionary('Car Hire/Title') : this.dictionary('Transfers/Transfers');
    const transferContent = transfer && transfer.toLowerCase() === 'no transfer' && !carHires ? "No Transfer" : "Included";
    const totalPax = search ? parseInt(search.TotalAdults) + parseInt(search.TotalChilds) + parseInt(search.TotalInfants) : 0;
    const price = selectedHotel ? selectedHotel.TotalPrice : 0;

    return (
      <div className={`MiniBasketOverlay ${isDesktop ? "MiniBasketOverlay-desktop" : "MiniBasketOverlay-mobile"}`}>
        <div className="MiniBasketOverlay_inner">
          <div className="MiniBasketOverlay_top">
            <div className="MiniBasketOverlay_atolText">{document.body.dataset.atolText}</div>
            <div className="MiniBasketOverlay_priceContainer">
              <span className="MiniBasketOverlay_price">{this.dictionary('Booking Details/Currency')}{(price / totalPax).toFixed(0)}</span><span className="MiniBasketOverlay_perPersonText"> /per person</span>
            </div>
            <div className="MiniBasketOverlay_detailsContainer">
              <div className="MiniBasketOverlay_detailLabel" onClick={event => this.updateMiniBasket(event, "Accommodation")}>
                <svg className="MiniBasketOverlay_detailLabelIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">  <path d="M15 7L8 14L5 11" stroke="#7EB583" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                <span>{moment(selectedHotel.StartDate).format('DD/MM/YY')} - {selectedHotel.Nights} nights</span>
              </div>

              {flights && 
                <div className="MiniBasketOverlay_detailLabel" onClick={event => this.updateMiniBasket(event, "Flights")}>
                  <svg className="MiniBasketOverlay_detailLabelIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">  <path d="M15 7L8 14L5 11" stroke="#7EB583" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  <span>{this.dictionary('Flights/Title')} - {flights.outboundFlight.AirportNameFrom}</span>
                </div>
              }
              {flights && 
                <div className="MiniBasketOverlay_detailLabel" onClick={event => this.updateMiniBasket(event, "Transfers")}>
                  <svg className="MiniBasketOverlay_detailLabelIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">  <path d="M15 7L8 14L5 11" stroke="#7EB583" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  <span>{transferText} {transferContent}</span>
                </div>
              }
              {extras && extras.length > 0 &&
                <div className="MiniBasketOverlay_detailLabel" onClick={event => this.updateMiniBasket(event, "Extras")}>
                  <svg className="MiniBasketOverlay_detailLabelIcon"xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">  <path d="M15 7L8 14L5 11" stroke="#7EB583" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                  <span>{extras[0].Name} Included</span>
                </div>
              }
            </div>
          </div>
          <div className="MiniBasketOverlay_bottom">
            <div className="MiniBasketOverlay_totalContainer">
              <span className="MiniBasketOverlay_totalText">{this.dictionary('Booking Details/Total')}</span>
              <span className="MiniBasketOverlay_totalPrice">{this.dictionary('Booking Details/Currency')}{(price).toFixed(0)}</span>
            </div>
            <div className="MiniBasketOverlay_buttonContainer">
              <button className="MiniBasketOverlay_button btn btn-outline" onClick={event => this.continueBookingProcess(event)}>Select Room</button>
            </div>
          </div>
        </div>
        <ViewMoreImages />
      </div>
    );
  }  
}
